import styled from 'styled-components';

export const SCicrleColor = styled.div<{ color: string }>`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background-color: ${({ color }) => color};
`;
